// @flow
import {
  createContext,
  useEffect,
  useState,
  useContext,
  useRef
} from 'react';

import useAxios from '../hooks/useAxios';
import { apiSeoContent } from '../app_routes/general';
import { handleError } from '../utils/errors';

import { CanonicalUrlStateContext } from './canonicalUrl';

import type { Node } from 'react';
import type { TSeoContent } from '../types/seo_content';

const defaultState = {
  url: '',
  h1: '',
  page_title: '',
  meta_desc: '',
  marketing_text: ''
};

export const SeoContentStateContext = createContext(defaultState);

export const SeoContentProvider = ({
  children,
  debounceRate = 0
}: {
  children: null | Node,
  debounceRate?: number
}) => {
  const isInitialLoad = useRef(true);
  const { url: canonicalUrl } = useContext(CanonicalUrlStateContext);
  const [content, setContent] = useState(defaultState);
  const axios = useAxios();

  (content: TSeoContent);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    if (!canonicalUrl) return;

    axios
      .get(apiSeoContent, { params: { url: canonicalUrl } })
      .then(res => setContent(res.data))
      .catch(handleError);
  }, [axios, canonicalUrl, setContent]);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    if (isInitialLoad.current) isInitialLoad.current = false;
  }, [content]);

  return (
    <SeoContentStateContext.Provider value={content}>
      {children}
    </SeoContentStateContext.Provider>
  );
};
